import styled from 'styled-components';

const Error = styled.div`
  width: 100%;
  text-align: center;
  color: #ff3030;
`;

export default Error;
